import { Component, Prop, h, Event, EventEmitter } from '@stencil/core';
import { InputFomat } from '../model/input.model';

@Component({
  tag: 'form-textarea',
  styleUrl: 'form-textarea.css',
  shadow: false,
})
export class FormTextarea {
    @Prop() inputValue: InputFomat;
    @Event() valueChanged: EventEmitter<{ id: string; value: any }>;
  render() {
    return (
        <div class="form-box">
            <label htmlFor={this.inputValue.id}>{this.inputValue.label || this.inputValue.id}</label>
            <ix-textarea
            id={this.inputValue.id}
            name={this.inputValue.id}
            value={this.inputValue.default || ''}
            placeholder={this.inputValue.placeholder || ''}
            required={this.inputValue.required || false}
            onInput={(e: Event) => {
                const target = e.target as HTMLTextAreaElement;
                this.valueChanged.emit({ id: this.inputValue.id, value: target.value });
            }}
            ></ix-textarea>
        </div>
    );
  }
}

